module.exports = __webpack_public_path__ + "static/img/Group262.8ef6c2c5.png";